import { MainRoutes } from "ui/common/router/MainRouter.types";
import { LocaleTranslationResource } from "ui/locale";
import { TransactionsRoutes } from "ui/transactions/router/TransactionsRouter";
import { TX_MODAL_TABS } from "ui/transactions/containers/ScanModal/hooks/useScanModalTabs";
import { HelpRoutes } from "ui/common/router/HelpRouter.types";

export const ROUTES_WITH_DIVIDER: string[] = [
    MainRoutes.PROGRAMS,
    MainRoutes.GIFT_CARDS,
    MainRoutes.GIFT_CARDS_DETAILS,
    HelpRoutes.HELP,
    MainRoutes.PARTNER_DETAILS,
    TransactionsRoutes.SEND_DETAILS,
    MainRoutes.PROFILE,
];

export const ROUTES_WITH_BACK_BUTTON: string[] = [
    MainRoutes.PROGRAM_DETAILS,
    MainRoutes.GIFT_CARDS,
    MainRoutes.GIFT_CARDS_DETAILS,
    MainRoutes.PARTNER_DETAILS,
    TransactionsRoutes.SEND_CONFIRMATION,
    TransactionsRoutes.SEND_DETAILS,
    TransactionsRoutes.SEND_OTP_CODE_VERIFICATION,
    TransactionsRoutes.SEND_SUCCESS,
];

export const APP_BAR_TITLES: Record<string, LocaleTranslationResource> = {
    ...Object.fromEntries(TX_MODAL_TABS.map((tab) => [MainRoutes.SEND_AND_RECEIVE.replace(":type", tab.path), tab.label])),
    [MainRoutes.PROGRAMS]: "programs",
    [MainRoutes.GIFT_CARDS]: "giftcards",
    [MainRoutes.GIFT_CARDS_DETAILS]: "details",
    [MainRoutes.GIFT_CARDS_PURCHASED]: "giftCardHistory",
    [TransactionsRoutes.MAIN]: "movements",
    [MainRoutes.PROGRAM_DETAILS]: "details",
    [MainRoutes.REDEEM]: "redeemPoints",
    [HelpRoutes.HELP]: "help",
    [MainRoutes.PARTNER_DETAILS]: "details",
    [MainRoutes.PROFILE]: "yourProfile",
    [TransactionsRoutes.SEND_DETAILS]: "send",
    [TransactionsRoutes.SEND_CONFIRMATION]: "confirm",
    [TransactionsRoutes.SEND_OTP_CODE_VERIFICATION]: "confirm",
};

export const ROUTES_WITHOUT_APP_BAR: string[] = [TransactionsRoutes.SEND_SUCCESS, MainRoutes.GIFT_CARDS_REDEEM];
